import moment from "moment";

export function formatPlansDateString (startDateString, endDateString) {
    const formatting = "MM/DD/YYYY";
    const startDate = moment(startDateString);
    const endDate = moment(endDateString);

    if (startDate.isValid() && endDate.isValid()) {
      return `${startDate.format(formatting)} - ${endDate.format(formatting)}`;
    }
    else {
      return "";
    }
  }